import { ReactNode, ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "ghost" | "destructive";
  size?: "default" | "sm" | "lg" | "icon";
  children: ReactNode;
}

const VARIANT_CLASSES: Record<string, string> = {
  default:     "bg-green-700 text-white hover:bg-green-800",
  outline:     "border-2 border-gray-400 bg-white text-gray-800 hover:bg-gray-50 hover:border-gray-600",
  ghost:       "bg-transparent text-green-700 hover:bg-green-50",
  destructive: "bg-red-600 text-white hover:bg-red-700",
};

const SIZE_CLASSES: Record<string, string> = {
  default: "px-4 py-2 text-sm",
  sm:      "px-3 py-1.5 text-xs",
  lg:      "px-6 py-3 text-base",
  icon:    "p-2",
};

export function Button({
  children,
  variant = "default",
  size = "default",
  className = "",
  disabled,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      disabled={disabled}
      className={`inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} ${className}`}
    >
      {children}
    </button>
  );
}
